import React from "react";
import styled from "styled-components";
import theme from "../../../styles/theme";
import headingStyles from "./headingStyles";

const { font, colors } = theme;

export const style = (props) => `
  font-family: ${font.recoletaSemiBold};
  color: ${colors.newBrand.black};
  margin-bottom: 25px;
  font-size: 54px;
  line-height: 64px;
`;

const H1 = styled.h1(headingStyles, (props) => style(props));

export default ({ children, ...props }) => <H1 {...props}>{children}</H1>;
